/** Validación de móvil del bundle (2b y 2c): prefijo obligatorio y 9 cifras tras +34. */
export type PhoneError = 'prefix' | 'digits' | null

export function phoneError(value: string): PhoneError {
  const compact = value.replace(/[\s().-]/g, '')
  if (compact === '' || !compact.startsWith('+')) return 'prefix'
  const digits = compact.slice(1)
  if (!/^\d+$/.test(digits)) return 'digits'
  if (digits.startsWith('34')) return digits.length === 11 ? null : 'digits'
  return digits.length >= 8 && digits.length <= 15 ? null : 'digits'
}
